import { z } from 'zod';
import { Option } from '../../types/Option';

export type DuctToDuctClearanceType = 'ducts-touching' | '0.25-m' | '0.5-m' | '1.0-m';

const options = [
    { value: 'ducts-touching', label: 'Touching' },
    { value: '0.25-m', label: '0.25 m' },
    { value: '0.5-m', label: '0.5 m' },
    { value: '1.0-m', label: '1.0 m' },
] as Option<DuctToDuctClearanceType>[];

const validator = z.enum(['ducts-touching', '0.25-m', '0.5-m', '1.0-m']);

export const DuctToDuctClearance = {
    validator,
    options,
};
